var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSourceSansProSemiBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "SourceSansPro-SemiBold_svg__SourceSansPro",
    horizAdvX: 540
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Source Sans Pro SemiBold",
    panose1: "2 11 6 3 3 4 3 2 2 4",
    ascent: 984,
    descent: -273,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    horizAdvX: 200
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    glyphName: "exclam",
    horizAdvX: 315,
    d: "M119 215l-16 341-3 114h116l-4-114-16-341h-77zm39-227q-32 0-53 22T83 66q0 34 21 56t54 22q32 0 53-22t21-56q0-34-21-56t-53-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    glyphName: "quotedbl",
    horizAdvX: 482,
    d: "M104 392L82 575l-4 113h118l-3-113-23-183h-66zm207 0l-22 183-4 113h118l-3-113-23-183h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    glyphName: "numbersign",
    horizAdvX: 513,
    d: "M88 0l24 195H35v76h85l16 129H55v76h91l22 174h69l-21-174h117l23 174h68l-21-174h80v-76h-89l-16-129h85v-76h-94L346 0h-70l23 195H182L158 0H88zm102 271h118l16 129H206l-16-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    glyphName: "dollar",
    horizAdvX: 513,
    d: "M218-110v100q-46 5-92 24T45 66l52 78q35-28 71-45t77-17q49 0 73 22t24 64q0 33-20 55t-50 40-66 34-65 39-51 54-20 79q0 70 40 116t108 59v102h80V646q48-6 82-27t63-51l-59-67q-28 26-54 39t-62 14q-41 0-64-20t-23-60q0-30 20-49t50-36 66-33 65-40 51-56 20-84q0-72-40-120T298-7v-103h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    glyphName: "percent",
    horizAdvX: 841,
    d: "M186 252q-69 0-112 54T30 460q0 99 43 152t113 54q69 0 112-53t44-153q0-99-43-153t-113-55zm0 67q32 0 52 33t21 108q0 74-20 106t-53 33q-32 0-52-32t-21-107q0-74 20-107t53-34zm20-331l357 678h70L277-12h-71zm449 0q-69 0-112 54t-44 154q0 99 43 152t113 54q69 0 112-53t44-153q0-99-43-153T655-12zm0 67q32 0 52 33t21 108q0 74-20 106t-53 33q-32 0-52-32t-21-107q0-74 20-107t53-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    glyphName: "ampersand",
    horizAdvX: 639,
    d: "M237-12q-49 0-87 14T84 41 43 99t-15 73q0 34 10 61t27 49 40 41 48 36q-20 38-31 74t-11 70q0 34 11 63t34 52 52 35 68 13q67 0 105-38t39-101q0-32-12-59t-32-49-45-43-53-39q30-41 68-79t81-71q27 36 48 79t35 95h106q-18-62-46-119t-66-108q32-20 62-33t56-19l-29-94q-38 9-78 26t-81 44q-39-32-88-51T237-12zm-30 516q0-23 7-46t19-50q41 26 69 53t28 65q0 26-12 44t-41 18q-31 0-50-23t-20-61zm44-427q27 0 53 10t52 29q-44 37-83 78t-72 87q-28-23-45-47t-18-55q0-46 32-74t81-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    glyphName: "quotesingle",
    horizAdvX: 275,
    d: "M104 392L82 575l-4 113h118l-3-113-23-183h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    glyphName: "parenleft",
    horizAdvX: 324,
    d: "M209-178Q146-75 112 35T77 278q0 133 34 243t98 213l72-32q-57-97-83-205t-27-219q0-111 26-219t84-205l-72-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    glyphName: "parenright",
    horizAdvX: 324,
    d: "M115-178l-72 32q57 97 83 205t27 219q0 111-26 219T43 702l72 32q63-103 97-213t35-243q0-133-34-243t-98-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    glyphName: "asterisk",
    horizAdvX: 438,
    d: "M143 384l-51 37 58 98-102 45 19 60 109-25 11 113h63l11-113 110 25 19-60-103-45 58-98-51-37-75 87-76-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    glyphName: "plus",
    horizAdvX: 513,
    d: "M213 99v189H34v84h179v189h87V372h179v-84H300V99h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    glyphName: "comma",
    horizAdvX: 275,
    d: "M72-182l-25 63q49 19 75 51t26 70h-9q-29 0-51 18T65 73q0 32 22 51t55 20q41 0 63-31t23-87q0-74-40-128T72-182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    glyphName: "hyphen",
    horizAdvX: 322,
    d: "M42 210v84h238v-84H42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    glyphName: "period",
    horizAdvX: 275,
    d: "M138-12q-32 0-53 22T63 66q0 34 21 56t54 22q32 0 53-22t21-56q0-34-21-56t-53-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    glyphName: "slash",
    horizAdvX: 344,
    d: "M12-160l233 870h78L90-160H12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    glyphName: "zero",
    horizAdvX: 513,
    d: "M256-12Q156-12 98 73T40 321q0 162 58 244t158 83q100 0 158-83t58-244q0-162-58-247T256-12zm0 90q23 0 42 12t34 42 22 75 8 114q0 67-8 112t-22 74-33 39-43 12q-23 0-42-11t-34-40-22-73-8-113q0-68 8-114t22-75 33-41 43-13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    glyphName: "one",
    horizAdvX: 513,
    d: "M74 0v94h142v418H99v72q48 9 82 21t65 31h86V94h125V0H74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    glyphName: "two",
    horizAdvX: 513,
    d: "M38 0v67q66 64 119 118t91 100 58 86 20 76q0 51-27 80t-78 30q-37 0-67-21t-57-50l-64 64q44 47 90 72t113 26q46 0 83-14t63-39 40-62 15-80q0-42-18-85t-50-88-74-92-89-97q25 2 54 4t52 3h156V0H38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    glyphName: "three",
    horizAdvX: 513,
    d: "M240-12q-78 0-130 26T24 78l55 74q29-29 66-49t85-21q52 0 84 25t33 71q0 25-9 45t-30 34-58 21-90 8v84q47 0 78 7t51 21 28 33 9 41q0 40-25 62t-69 23q-38 0-68-16t-60-44l-59 71q41 36 87 58t104 22q46 0 84-11t65-32 42-53 15-72q0-54-29-90t-82-56v-4q57-15 94-55t38-103q0-44-17-78t-48-57-71-36-87-13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    glyphName: "four",
    horizAdvX: 513,
    d: "M299 0v164H18v78l252 394h137V253h80v-89h-80V0H299zM132 253h167v144q0 28 1 66t4 66h-4q-12-25-25-49t-27-50L132 253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    glyphName: "five",
    horizAdvX: 513,
    d: "M241-12q-77 0-129 26T24 76l53 74q29-27 65-47t84-21q54 0 88 32t35 90q0 57-32 88t-85 31q-31 0-52-8t-50-28l-55 35 19 314h340v-97H194l-13-154q20 10 39 15t45 6q41 0 77-12t64-36 43-62 16-89q0-52-18-93t-50-69-71-42-85-15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    glyphName: "six",
    horizAdvX: 513,
    d: "M275-12q-47 0-89 18t-73 57-50 97-19 139q0 93 21 159t55 108 80 62 94 20q58 0 99-21t71-51l-62-70q-17 21-44 34t-57 14q-30 0-56-12t-47-39-32-73-15-111q28 35 65 55t73 20q41 0 75-12t59-36 38-62 14-87q0-48-16-86t-43-66-63-42-78-15zm-2 88q40 0 67 31t28 90q0 57-26 85t-74 28q-27 0-57-16t-57-57q9-85 40-123t79-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    glyphName: "seven",
    horizAdvX: 513,
    d: "M168 0q4 85 15 155t31 135 53 124 78 125H44v97h427v-70q-56-69-90-131t-55-128-28-140T285 0H168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    glyphName: "eight",
    horizAdvX: 513,
    d: "M257-12q-47 0-86 13t-68 36-45 55-17 71q0 30 9 54t26 45 36 36 44 28v4q-37 26-62 62t-26 87q0 39 14 70t40 53 61 34 77 12q43 0 77-12t59-35 38-54 13-71q0-24-7-45t-20-40-27-34-31-27v-4q22-12 42-27t35-36 24-45 9-57q0-37-15-68t-44-55-68-37-88-13zm42 371q26 26 39 53t14 57q0 42-24 69t-70 28q-37 0-62-22t-25-65q0-24 10-42t27-31 41-25 50-22zM259 70q46 0 75 25t30 70q0 26-12 44t-32 33-49 27-60 25q-30-22-49-52t-20-67q0-48 34-76t83-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    glyphName: "nine",
    horizAdvX: 513,
    d: "M244 326q28 0 58 17t56 57q-9 84-41 122t-79 38q-39 0-67-31t-28-89q0-57 26-85t75-29zM217-12q-57 0-99 21T47 60l62 70q18-21 45-34t57-14q30 0 56 12t47 39 32 73 15 111q-28-35-66-54t-73-20q-41 0-75 12t-58 36-38 62-14 87q0 48 16 86t43 66 63 41 78 15q46 0 88-18t73-57 50-96 19-139q0-93-20-159T392 71 312 8t-95-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    glyphName: "colon",
    horizAdvX: 275,
    d: "M138 330q-32 0-53 22t-22 56q0 34 21 56t54 22q32 0 53-22t21-56q0-34-21-56t-53-22zm0-342q-32 0-53 22T63 66q0 34 21 56t54 22q32 0 53-22t21-56q0-34-21-56t-53-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    glyphName: "semicolon",
    horizAdvX: 275,
    d: "M138 330q-32 0-53 22t-22 56q0 34 21 56t54 22q32 0 53-22t21-56q0-34-21-56t-53-22zM72-182l-25 63q49 19 75 51t26 70h-9q-29 0-51 18T65 73q0 32 22 51t55 20q41 0 63-31t23-87q0-74-40-128T72-182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    glyphName: "less",
    horizAdvX: 513,
    d: "M479 117L34 290v84l445 173v-97l-193-68-135-48v-4l135-48 193-68v-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    glyphName: "equal",
    horizAdvX: 513,
    d: "M34 400v84h445v-84H34zm0 33v84h445v-84H34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    glyphName: "greater",
    horizAdvX: 513,
    d: "M34 117v97l193 68 135 48v4l-135 48-193 68v97l445-173v-84L34 117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    glyphName: "question",
    horizAdvX: 444,
    d: "M157 215q-5 36 2 66t22 55 33 46 35 42 28 41 11 43q0 36-21 58t-60 22q-31 0-56-14t-47-38l-64 59q33 38 78 62t103 25q39 0 72-10t56-32 37-52 14-72q0-32-11-57t-29-49-36-44-35-44-25-49-6-58H157zm51-227q-32 0-53 22t-21 56q0 34 21 56t53 22q32 0 53-22t22-56q0-34-21-56t-54-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    glyphName: "at",
    horizAdvX: 875,
    d: "M416-164q-74 0-140 23T159-72 80 43 50 204q0 103 35 186t94 143 138 92 167 33q78 0 141-25t108-70 69-109 24-140q0-67-19-117t-51-85-69-51-75-17q-43 0-73 19t-37 57h-2q-23-30-56-49t-65-19q-55 0-90 38t-36 108q0 43 14 85t41 77 62 55 80 22q52 0 78-49h2l13 41h73l-43-211q-25-101 50-101 23 0 46 13t41 39 29 60 11 81q0 57-16 107t-50 87-86 60-123 22q-66 0-128-27t-110-76-77-119-30-156q0-74 23-130t63-93 94-57 115-19q42 0 83 11t74 30l27-64q-88-50-193-50zm-13 291q18 0 37 12t42 40l26 147q-22 35-55 35-26 0-46-15t-35-38-22-50-8-53q0-41 16-59t45-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    glyphName: "A",
    horizAdvX: 558,
    d: "M217 348l-23-80h167l-23 80q-16 52-30 107t-29 109h-4q-14-55-28-109t-30-107zM-2 0l213 654h136L560 0H438l-51 177H167L116 0H-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    glyphName: "B",
    horizAdvX: 597,
    d: "M83 0v654h209q51 0 93-8t74-27 49-50 18-76q0-47-24-87t-67-55v-4q54-12 89-50t36-105q0-49-19-85t-52-60-80-35T309 0H83zm116 384h83q69 0 99 25t31 67q0 48-32 68t-96 20h-85V384zm0-294h98q72 0 111 26t39 82q0 52-38 75t-112 24h-98V90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    glyphName: "C",
    horizAdvX: 576,
    d: "M344-12q-62 0-116 22t-93 65-63 106-23 144q0 80 23 143t64 108 95 67 117 23q62 0 110-25t79-58l-62-75q-26 26-56 41t-68 16q-40 0-73-16t-58-47-38-75-14-99q0-112 48-175t132-64q44 0 78 18t62 49l62-73q-40-46-91-70T344-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    glyphName: "D",
    horizAdvX: 625,
    d: "M83 0v654h175q150 0 234-81t84-243q0-81-21-143T493 84t-98-63T264 0H83zm116 94h51q100 0 153 57t54 179q0 120-54 175t-153 55h-51V94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    glyphName: "E",
    horizAdvX: 538,
    d: "M83 0v654h394v-98H199V389h235v-98H199V98h288V0H83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    glyphName: "F",
    horizAdvX: 510,
    d: "M83 0v654h395v-98H199V371h238v-98H199V0H83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    glyphName: "G",
    horizAdvX: 628,
    d: "M357-12q-66 0-122 22t-98 65-65 106-23 144q0 80 24 143t65 108 98 67 122 23q70 0 118-25t80-58l-62-75q-25 24-55 40t-77 17q-44 0-79-16t-61-47-40-75-14-99q0-112 50-175t150-64q28 0 53 7t41 22v141H338v95h228V66q-33-33-87-55T357-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    glyphName: "H",
    horizAdvX: 663,
    d: "M83 0v654h116V391h265v263h116V0H464v290H199V0H83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    glyphName: "I",
    horizAdvX: 282,
    d: "M83 0v654h116V0H83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    glyphName: "J",
    horizAdvX: 494,
    d: "M219-12q-69 0-116 28T24 99l80 59q20-36 46-52t56-17q46 0 69 28t23 98v439h116V205q0-45-11-84t-35-69-61-47-88-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    glyphName: "K",
    horizAdvX: 597,
    d: "M83 0v654h116V357h3l233 297h129L363 399 598 0H470L293 308l-94-117V0H83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    glyphName: "L",
    horizAdvX: 502,
    d: "M83 0v654h116V98h272V0H83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    glyphName: "M",
    horizAdvX: 745,
    d: "M83 0v654h131l116-320q11-31 21-63t21-65h4q11 32 20 64t21 64l113 320h132V0H555v299q0 23 1 50t4 54 5 54 5 50h-4l-53-152L406 61h-69L229 355l-52 152h-4q2-23 4-49t5-54 4-55 2-50V0H83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    glyphName: "N",
    horizAdvX: 656,
    d: "M83 0v654h119l204-368 67-139h4q-4 51-9 109t-6 114v284h111V0H454L250 368l-67 139h-4q4-52 9-109t6-112V0H83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    glyphName: "O",
    horizAdvX: 674,
    d: "M337-12q-64 0-117 23t-91 68-59 108-21 143q0 79 21 141t59 106 91 66 117 23q64 0 117-23t91-66 60-105 21-142q0-80-21-143T546 80t-92-68-117-24zm0 101q39 0 70 17t53 48 34 76 12 100q0 110-45 172t-124 63q-78 0-123-62t-46-173q0-55 12-99t34-76 53-49 70-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    glyphName: "P",
    horizAdvX: 582,
    d: "M83 0v654h206q54 0 100-10t81-34 53-62 19-96q0-54-19-94t-52-66-79-39-99-13h-94V0H83zm116 333h85q144 0 144 119 0 62-37 85t-111 24h-81V333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    glyphName: "Q",
    horizAdvX: 674,
    d: "M337 83q39 0 70 17t53 49 34 78 12 103q0 110-45 172t-124 63q-78 0-123-62t-46-173q0-57 12-103t34-78 53-49 70-17zm208-257q-98 0-164 47T283-7q-53 9-96 36t-74 71-47 101-17 129q0 79 21 141t59 106 91 66 117 23q64 0 117-23t91-66 60-105 21-142q0-68-15-124t-45-100-69-71-91-39q23-39 63-57t89-18q22 0 39 2t32 8l21-86q-17-8-44-13t-61-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    glyphName: "R",
    horizAdvX: 592,
    d: "M83 0v654h221q51 0 95-10t76-32 50-60 19-92q0-75-35-121t-95-66L570 0H440L299 256H199V0H83zm116 348h93q67 0 102 28t36 84q0 57-35 79t-103 22h-93V348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    glyphName: "S",
    horizAdvX: 545,
    d: "M274-12q-66 0-127 25T38 84l68 79q35-33 80-53t90-21q56 0 85 23t29 61q0 20-7 34t-21 24-32 20-41 18l-90 39q-24 10-47 25t-43 36-30 49-12 64q0 39 16 72t46 59 69 39 89 14q57 0 110-22t91-61l-59-74q-32 26-66 41t-76 15q-47 0-75-20t-28-57q0-19 8-32t23-24 34-19 39-17l89-37q29-12 53-28t41-37 28-48 10-64q0-40-16-75t-46-61-74-42-99-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    glyphName: "T",
    horizAdvX: 546,
    d: "M215 0v556H26v98h494v-98H331V0H215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    glyphName: "U",
    horizAdvX: 655,
    d: "M328-12q-57 0-102 16t-78 53-50 92-18 138v367h116V278q0-53 9-89t27-59 42-31 54-10q30 0 55 9t43 32 28 58 10 90v376h111V287q0-81-17-137t-49-93-78-52-103-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    glyphName: "V",
    horizAdvX: 536,
    d: "M200 0L-4 654h123l92-329q16-56 28-106t30-107h4q17 57 29 107t28 106l91 329h119L337 0H200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    glyphName: "W",
    horizAdvX: 800,
    d: "M148 0L18 654h119l57-330q8-53 16-105t16-104h4q11 52 21 104t22 105l80 330h101l80-330q11-51 22-103t22-106h4q8 53 15 105t16 104l57 330h111L656 0H512l-81 344q-8 38-15 75t-14 76h-4q-7-38-14-75t-16-76L289 0H148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    glyphName: "X",
    horizAdvX: 541,
    d: "M13 0l186 337L25 654h129l72-145q12-23 23-47t27-53h4q12 29 22 53t22 47l69 145h123L342 332 528 0H399l-80 154q-13 26-25 51t-28 56h-4q-13-30-24-55t-24-52L136 0H13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    glyphName: "Y",
    horizAdvX: 501,
    d: "M192 0v243L-4 654h124l71-167q14-37 28-71t30-73h4q16 38 31 72t29 72l71 167h121L308 243V0H192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    glyphName: "Z",
    d: "M40 0v70l316 486H69v98h431v-70L183 98h319V0H40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    glyphName: "bracketleft",
    horizAdvX: 324,
    d: "M90-152v860h196v-63H177V-89h109v-63H90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    glyphName: "backslash",
    horizAdvX: 344,
    d: "M255-160L21 710h78l234-870h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    glyphName: "bracketright",
    horizAdvX: 324,
    d: "M38-152v63h109v734H38v63h196v-860H38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    glyphName: "asciicircum",
    horizAdvX: 513,
    d: "M55 279l153 391h96l154-391h-97l-55 151-48 135h-4l-47-135-55-151H55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    glyphName: "underscore",
    horizAdvX: 500,
    d: "M12-133v69h476v-69H12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    glyphName: "grave",
    horizAdvX: 549,
    d: "M276 573L106 728l80 76 147-174-57-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    glyphName: "a",
    horizAdvX: 516,
    d: "M192-12q-65 0-105 39T47 132q0 39 16 69t52 53 90 37 131 23q-1 19-5 36t-15 31-28 21-42 8q-36 0-70-14t-68-34l-42 77q41 26 92 45t110 19q92 0 137-54t46-158V0h-95l-8 54h-4q-33-28-70-47t-82-19zm37 90q30 0 54 14t53 40v110q-50-6-84-16t-55-22-30-29-9-34q0-33 20-48t51-15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    glyphName: "b",
    horizAdvX: 563,
    d: "M311-12q-34 0-68 16t-66 48h-3L164 0H73v706h115V524l-3-82q31 27 67 44t75 17q46 0 82-17t61-50 38-79 13-103q0-63-17-112t-47-84-67-52-79-18zm-24 95q49 0 82 42t33 127q0 74-25 115t-81 41q-52 0-108-55V124q26-23 51-32t48-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    glyphName: "c",
    horizAdvX: 462,
    d: "M278-12q-50 0-93 17t-76 50-50 81-18 109q0 61 20 109t54 81 78 50 94 18q48 0 82-16t62-39l-56-75q-20 17-39 26t-43 10q-60 0-97-44t-37-120q0-74 36-118t95-45q29 0 54 12t47 30l47-76q-35-30-76-45t-84-15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    glyphName: "d",
    horizAdvX: 564,
    d: "M245-12q-93 0-147 67T43 245q0 60 17 108t47 81 66 51 78 18q42 0 71-14t58-40l-4 79v178h115V0h-95l-8 53h-4q-27-27-63-46t-76-19zm28 95q55 0 103 55v229q-26 23-50 32t-50 9q-48 0-81-42t-33-120q0-80 28-121t83-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    glyphName: "e",
    horizAdvX: 507,
    d: "M283-12q-51 0-95 17t-77 51-51 80-19 109q0 60 19 108t50 81 73 51 84 18q50 0 88-17t63-48 39-74 13-94q0-17-1-32t-4-24H153q8-66 46-101t99-36q32 0 59 9t55 27l39-72q-35-23-78-38t-90-15zM152 292h218q0 57-24 89t-76 33q-44 0-77-31t-41-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    glyphName: "f",
    horizAdvX: 317,
    d: "M93 0v400H27v86l66 5v51q0 38 9 70t29 56 50 37 75 13q26 0 49-5t41-12l-22-86q-27 12-54 12-62 0-62-83v-53h96v-91h-96V0H93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    glyphName: "g",
    horizAdvX: 520,
    d: "M244-217q-44 0-81 8t-65 24-42 40-16 56q0 31 18 57t52 48v4Q91 32 79 52t-13 50q0 29 16 52t38 39v4q-25 19-44 52t-20 78q0 42 16 75t42 55 62 34 74 12q20 0 38-3t34-9h176v-85h-90q12-14 20-35t8-48q0-41-14-72t-40-52-59-32-73-11q-16 0-33 3t-34 10q-11-10-17-20t-7-27q0-21 17-33t63-12h87q89 0 134-28t46-93q0-36-18-68t-53-55-82-36-109-14zm6 445q35 0 60 25t25 74q0 46-24 71t-61 26q-36 0-61-25t-25-72q0-48 25-73t61-26zm12-370q60 0 96 23t37 56q0 29-22 39t-65 10h-67q-40 0-67 7-38-29-38-65 0-33 33-51t93-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    glyphName: "h",
    horizAdvX: 558,
    d: "M73 0v706h115V524l-4-95q31 29 68 51t89 23q79 0 115-50t36-145V0H377v293q0 61-18 86t-59 25q-32 0-56-15t-56-46V0H73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    glyphName: "i",
    horizAdvX: 262,
    d: "M73 0v491h115V0H73zm58 577q-31 0-51 18t-20 47q0 29 20 47t51 19q31 0 51-18t20-48q0-29-20-47t-51-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    glyphName: "j",
    horizAdvX: 263,
    d: "M34-206q-27 0-46 4t-34 9l22 86q10-3 20-5t22-3q33 0 44 22t12 66v518h116V-25q0-39-8-72t-26-57-49-38-73-14zm98 783q-30 0-50 18t-21 47q0 29 20 47t51 19q31 0 51-18t21-48q0-29-20-47t-52-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    glyphName: "k",
    horizAdvX: 522,
    d: "M73 0v706h113V265h3l182 226h126L329 291 514 0H389L263 213l-77-88V0H73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    glyphName: "l",
    horizAdvX: 271,
    d: "M185-12q-62 0-87 37T73 126v580h115V120q0-21 8-29t17-9h7q3 0 11 2l15-86q-23-10-61-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    glyphName: "m",
    horizAdvX: 843,
    d: "M73 0v491h95l8-67h4q31 33 67 56t83 23q54 0 86-23t50-65q35 38 73 63t85 25q78 0 115-50t37-145V0H660v293q0 61-18 86t-57 25q-46 0-103-61V0H367v293q0 61-18 86t-58 25q-46 0-103-61V0H73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    glyphName: "n",
    horizAdvX: 560,
    d: "M73 0v491h95l8-66h4q33 32 71 55t90 23q79 0 115-50t36-145V0H377v293q0 61-18 86t-59 25q-32 0-56-15t-56-46V0H73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    glyphName: "o",
    horizAdvX: 549,
    d: "M274-12q-46 0-88 17t-74 50-52 81-19 109q0 61 19 109t51 81 75 50 88 18q46 0 88-17t75-51 51-81 20-109q0-61-19-109t-52-81-74-50-89-17zm0 94q54 0 85 44t31 119q0 75-31 119t-85 45q-54 0-84-44t-31-120q0-74 30-118t85-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    glyphName: "p",
    horizAdvX: 564,
    d: "M73-194v685h95l8-52h4q31 26 69 45t79 19q46 0 81-17t61-51 38-79 13-103q0-63-17-112t-47-83-67-52-79-18q-32 0-64 14t-62 40l3-82v-154H73zM287 83q49 0 82 42t33 127q0 74-25 115t-81 41q-52 0-108-55V124q27-23 52-32t47-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    glyphName: "q",
    horizAdvX: 564,
    d: "M376-194v161l4 82q-27-26-62-43t-73-18q-93 0-147 67T43 245q0 60 17 108t47 81 66 51 78 18q42 0 73-14t63-45h3l10 47h91v-685H376zM273 83q55 0 103 55v229q-26 23-50 32t-50 9q-48 0-81-42t-33-120q0-80 28-121t83-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    glyphName: "r",
    horizAdvX: 373,
    d: "M73 0v491h95l8-87h4q26 48 63 73t76 26q35 0 56-10l-20-100q-13 4-24 6t-27 2q-29 0-61-22t-55-79V0H73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    glyphName: "s",
    horizAdvX: 431,
    d: "M210-12q-51 0-100 19T24 56l54 74q33-26 65-40t71-15q40 0 59 16t19 43q0 15-9 26t-24 21-34 16-38 16q-24 9-49 21t-44 29-32 39-13 54q0 65 48 106t131 41q51 0 92-18t71-41l-53-70q-26 19-52 30t-56 12q-37 0-54-15t-18-39q0-15 8-25t23-19 32-15 39-14q25-9 50-20t45-29 33-41 13-59q0-32-12-59t-37-48-60-33-82-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    glyphName: "t",
    horizAdvX: 361,
    d: "M246-12q-43 0-72 13t-48 36-27 56-9 73v234H20v86l76 5 14 134h96V491h125v-91H206V166q0-86 69-86 13 0 26 3t25 8l20-85q-20-7-45-12t-55-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    glyphName: "u",
    horizAdvX: 556,
    d: "M219-12q-79 0-115 50T68 183v308h115V198q0-61 18-86t58-25q32 0 56 16t53 52v336h115V0h-94l-9 72h-3q-32-38-69-61t-89-23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    glyphName: "v",
    horizAdvX: 495,
    d: "M183 0L12 491h117l78-255q10-36 20-73t21-75h4q11 38 21 75t21 73l78 255h111L316 0H183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    glyphName: "w",
    horizAdvX: 748,
    d: "M154 0L24 491h116l59-255q8-35 13-70t13-71h4q7 36 14 71t17 70l64 255h105l65-255q9-35 17-70t16-71h4q7 36 13 71t13 70l59 255h108L599 0H462l-57 229q-8 35-15 69t-15 74h-4q-7-39-14-74t-15-70L286 0H154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    glyphName: "x",
    horizAdvX: 481,
    d: "M14 0l156 256L24 491h124l55-93q11-20 22-41t23-42h4q9 20 19 41t19 42l47 93h119L311 243 467 0H343l-60 97-24 44q-12 22-26 43h-4q-11-21-21-42t-22-45L134 0H14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    glyphName: "y",
    horizAdvX: 495,
    d: "M106-202q-20 0-35 2t-29 8l21 90q7-2 16-4t19-3q39 0 62 23t36 61l9 31L12 491h117l85-241q11-32 21-67t22-71h4q9 34 18 69t19 69l74 241h111L305-22q-15-42-33-75t-41-56-54-36-71-13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    glyphName: "z",
    horizAdvX: 443,
    d: "M34 0v62l232 338H60v91h350v-61L179 92h239V0H34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    glyphName: "braceleft",
    horizAdvX: 324,
    d: "M232-152q-32 0-55 6t-38 23-22 42-8 67q0 27 1 49t3 44 3 42 2 46q0 14-4 27t-14 24-26 18-42 7v70q25 0 41 7t27 17 14 24 4 27q0 25-1 46t-3 43-3 43-2 50q0 40 7 66t23 43 38 22 55 7h54v-63h-23q-36 0-48-17t-13-63q0-43 2-83t3-89q0-54-16-79t-51-34v-4q35-9 51-34t16-79q0-48-2-88t-3-84q0-45 12-62t49-18h23v-63h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    glyphName: "bar",
    horizAdvX: 255,
    d: "M89-250V750h77V-250H89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    glyphName: "braceright",
    horizAdvX: 324,
    d: "M38-152v63h23q36 0 48 17t13 63q0 43-2 83t-3 89q0 53 16 78t51 35v4q-35 9-51 34t-16 79q0 48 2 88t3 84q0 45-12 62t-49 18H38v63h54q31 0 54-6t39-23 22-42 8-67q0-27-1-49t-3-44-3-42-2-47q0-14 4-27t14-23 26-18 42-7v-70q-25 0-41-7t-27-17-14-24-4-28q0-24 1-45t3-43 3-43 2-50q0-40-7-66t-23-43-38-22-55-7H38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    glyphName: "asciitilde",
    horizAdvX: 513,
    d: "M343 248q-30 0-53 12t-44 28-38 27-40 13q-42 0-74-59l-62 46q32 52 67 74t71 23q30 0 53-12t44-28 38-27 40-13q42 0 74 59l61-47q-32-51-67-73t-70-23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    horizAdvX: 205
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA1",
    glyphName: "exclamdown",
    horizAdvX: 315,
    d: "M100-179l3 114 16 341h77l16-341 4-114H100zm58 526q-32 0-53 22t-22 57q0 33 21 55t54 22q32 0 53-22t21-55q0-35-21-57t-53-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA2",
    glyphName: "cent",
    horizAdvX: 513,
    d: "M173 308q0-56 25-94t71-52v293q-46-15-71-53t-25-94zm96-345v99q-94 12-151 75T61 308q0 52 16 94t43 74 66 50 83 27v101h66v-98q42-2 73-18t55-39l-54-71q-35 31-74 35V155q26 2 48 14t40 27l48-73q-29-26-64-41t-72-21v-98h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA3",
    glyphName: "sterling",
    horizAdvX: 513,
    d: "M51 0v71q48 24 77 67t29 99q0 11-1 20t-3 21H53v69l67 5h12q-8 26-14 51t-7 51q0 45 14 81t41 61 64 38 81 14q55 0 94-21t70-57l-64-63q-19 22-40 34t-50 13q-47 0-73-27t-26-79q0-25 5-48t12-48h154v-74H256q3-20 3-42 0-45-13-75t-40-59v-4h270V0H51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA4",
    glyphName: "currency",
    horizAdvX: 513,
    d: "M82 93l-59 60 62 63q-17 23-26 51t-9 62q0 34 9 62t26 52l-62 63 59 60 68-70q48 31 106 31t106-31l69 70 59-60-63-63q17-23 26-51t9-63q0-33-9-61t-26-52l63-63-59-60-69 70q-23-16-50-23t-56-8q-28 0-55 7t-50 24L82 93zm174 121q43 0 72 31t30 84q0 53-29 84t-73 32q-42 0-72-31t-30-85q0-52 30-83t72-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA5",
    glyphName: "yen",
    horizAdvX: 513,
    d: "M198 0v152H41v60h157v59H41v59h131L18 636h119l64-151q14-33 27-66t28-67h4q14 34 27 67t28 66l64 151h116L340 330h132v-59H314v-59h158v-60H314V0H198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA6",
    glyphName: "brokenbar",
    horizAdvX: 255,
    d: "M89 302v448h77V302H89zm0-552v459h77v-459H89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA7",
    glyphName: "section",
    horizAdvX: 513,
    d: "M140 342q0-28 18-46t45-34 61-28 63-31q23 12 34 29t12 43q0 28-17 47t-45 35-61 28-63 30q-23-14-35-31t-12-42zm98-416q-54 0-103 20T54 4l68 60q25-25 53-38t63-14q35 0 53 16t19 40q0 24-20 40t-50 30-64 29-65 36-50 53-20 78q0 41 22 74t61 55q-30 33-30 82 0 30 10 56t32 45 51 30 71 11q53 0 95-19t73-42l-54-73q-23 20-50 33t-58 14q-35 0-50-14t-16-36q0-23 20-38t51-30 66-30 66-38 50-53 21-77q0-46-22-77t-61-54q12-16 19-35t7-45q0-32-12-58t-35-47-56-31-74-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA8",
    glyphName: "dieresis",
    horizAdvX: 549,
    d: "M171 578q-26 0-43 17t-18 44q0 26 17 43t44 18q27 0 44-17t17-44q0-26-17-43t-44-18zm206 0q-27 0-44 17t-17 44q0 26 17 43t44 18q26 0 43-17t18-44q0-26-17-43t-44-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA9",
    glyphName: "copyright",
    horizAdvX: 747,
    d: "M374-10q-66 0-125 23T145 80 74 185 47 324q0 77 26 138t71 104 104 65 126 23q66 0 125-22t103-66 71-104 27-138q0-77-26-138T603 81 499 14 374-10zm0 52q56 0 105 20t85 58 57 89 21 115q0 63-21 114t-57 88-85 57-105 20q-56 0-105-20t-85-56-58-88-21-115q0-63 21-115t57-89 86-57 105-21zm10 84q-40 0-74 13t-60 39-39 62-15 83q0 44 15 79t42 60 61 38 71 14q45 0 75-17t54-41l-45-50q-19 18-37 27t-41 10q-51 0-80-34t-29-86q0-58 28-92t77-34q29 0 50 11t41 28l39-56q-28-23-59-38t-74-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAA",
    glyphName: "ordfeminine",
    horizAdvX: 352,
    d: "M133 377q-46 0-73 27t-27 70q0 53 45 81t148 38q-2 27-14 43t-42 16q-23 0-47-9t-48-23l-30 55q29 17 64 30t75 13q125 0 125-141V385h-67l-8 35h-4q-20-18-44-30t-53-13zm27 64q17 0 33 8t33 25v70q-63-8-87-24t-25-39q0-40 46-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAB",
    glyphName: "guillemotleft",
    horizAdvX: 456,
    d: "M182 61L47 210v84l135 149 46-37-115-154L228 97l-46-36zm174 0L221 210v84l135 149 46-37-115-154L402 97l-46-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAC",
    glyphName: "logicalnot",
    horizAdvX: 513,
    d: "M392 99v189H34v84h445V99h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAD",
    glyphName: "uni00AD",
    horizAdvX: 322,
    d: "M42 210v84h238v-84H42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAE",
    glyphName: "registered",
    horizAdvX: 443,
    d: "M221 315q-40 0-75 14t-61 41-42 63-15 81q0 44 15 81t41 63 62 41 75 15q40 0 75-14t61-41 42-64 15-81q0-44-15-80t-41-63-62-41-75-15zm0 43q31 0 58 11t46 32 31 49 11 64q0 35-11 64t-30 50-47 32-58 12q-32 0-58-11t-46-33-31-50-11-64q0-35 11-63t30-49 46-32 59-12zm-77 59v199h83q33 0 56-15t24-50q0-17-9-32t-28-23l44-79h-53l-33 65h-34v-65h-50zm50 101h23q17 0 27 8t10 22q0 13-8 21t-28 9h-24v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAF",
    glyphName: "overscore",
    horizAdvX: 549,
    d: "M134 596v76h280v-76H134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB0",
    glyphName: "degree",
    horizAdvX: 348,
    d: "M175 413q-28 0-52 10t-43 28-29 43-11 55q0 30 10 55t29 43 43 28 53 10q28 0 52-10t43-28 29-43 11-55q0-30-10-55t-29-43-43-28-53-10zm0 59q32 0 51 21t20 56q0 35-19 56t-52 22q-32 0-51-21t-20-57q0-34 19-55t52-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB1",
    glyphName: "plusminus",
    horizAdvX: 513,
    d: "M213 143v156H34v83h179v179h87V382h179v-83H300V143h-87zM34 0v83h445V0H34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB2",
    glyphName: "two.sups",
    horizAdvX: 372,
    d: "M48 385v48q84 72 131 121t47 90q0 33-17 52t-49 19q-22 0-41-14t-36-38l-50 46q26 37 62 57t78 21q62 0 99-33t38-96q0-26-9-50t-27-48-39-50-49-52h141v-73H48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB3",
    glyphName: "three.sups",
    horizAdvX: 372,
    d: "M183 373q-50 0-89 21t-63 57l54 42q36-53 91-53 28 0 47 15t20 43q0 29-27 44t-80 16v51q43 0 67 16t25 44q0 23-16 37t-43 14q-20 0-38-12t-34-31l-50 44q29 32 60 49t76 17q26 0 49-7t42-21 28-34 11-45q0-33-16-55t-46-38q32-11 54-34t23-61q0-27-11-49t-32-37-46-24-56-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB4",
    glyphName: "acute",
    horizAdvX: 549,
    d: "M272 573l-57 57 147 174 80-76-170-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB5",
    glyphName: "uni00B5",
    horizAdvX: 578,
    d: "M73-178v669h115V198q0-59 18-85t57-26q29 0 54 16t53 63v325h116q-1-46-2-95t-3-98-2-93-1-82q0-23 11-32t29-9q6 0 14 1t16 5l15-86q-14-6-30-10t-43-4q-92 0-108 88h-4q-22-42-52-63T259-8q-24 0-44 6t-34 28v-57q0-25 2-49t2-47 5-51H73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB6",
    glyphName: "paragraph",
    horizAdvX: 599,
    d: "M387-80v734h116V-80H387zm-92 292q-54 0-100 13t-81 42-54 70-20 99q0 61 19 102t52 67 79 37 98 12h44V212h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB7",
    glyphName: "middot",
    horizAdvX: 275,
    d: "M138 243q-32 0-53 22t-22 56q0 34 21 56t54 22q32 0 53-22t21-56q0-34-21-56t-53-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB8",
    glyphName: "cedilla",
    horizAdvX: 549,
    d: "M184-233l-10 50q61 4 83 14t23 33q0 17-16 28t-61 17l46 94h70l-29-65q36-9 55-25t20-48q0-48-47-71t-134-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB9",
    glyphName: "one.sups",
    horizAdvX: 372,
    d: "M168 385v294H82v54q37 6 59 15t45 27h69V385h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBA",
    glyphName: "ordmasculine",
    horizAdvX: 369,
    d: "M184 377q-32 0-60 11t-50 34-34 53-13 72q0 40 12 72t35 54 50 33 60 12q31 0 59-11t51-34 34-54 13-72q0-40-12-71t-35-54-50-33-60-12zm0 67q35 0 53 28t19 75q0 48-18 76t-54 29q-35 0-53-28t-19-77q0-47 18-75t54-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBB",
    glyphName: "guillemotright",
    horizAdvX: 456,
    d: "M99 61L54 97l114 155L54 406l45 37 136-149v-84L99 61zm174 0l-45 36 114 155-114 154 45 37 136-149v-84L273 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBC",
    glyphName: "onequarter",
    horizAdvX: 795,
    d: "M142 264v294H56v54q37 6 59 15t45 27h69V264h-87zm41-276l357 678h70L254-12h-71zM640 0v95H461v44l152 251h104V154h58V95h-58V0h-77zm-95 154h95v55l5 113h-4l-45-79-51-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBD",
    glyphName: "onehalf",
    horizAdvX: 827,
    d: "M142 264v294H56v54q37 6 59 15t45 27h69V264h-87zm23-276l357 678h70L236-12h-71zM503 0v48q84 72 131 121t47 90q0 33-17 52t-49 19q-22 0-41-14t-36-38l-50 46q26 37 62 57t78 21q62 0 99-33t38-96q0-26-9-50t-27-48-39-50-49-52h141V0H503z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBE",
    glyphName: "threequarters",
    horizAdvX: 807,
    d: "M182 252q-50 0-89 21t-63 57l54 42q36-53 91-53 28 0 47 15t20 43q0 29-27 44t-80 16v51q43 0 67 16t25 44q0 23-16 37t-43 14q-20 0-38-12t-34-31l-50 44q29 32 60 49t76 17q26 0 49-7t42-21 28-34 11-45q0-33-16-55t-46-38q32-11 54-34t23-61q0-27-11-49t-32-37-46-24-56-9zm30-264l357 678h70L283-12h-71zM652 0v95H473v44l152 251h104V154h58V95h-58V0h-77zm-95 154h95v55l5 113h-4l-45-79-51-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBF",
    glyphName: "questiondown",
    horizAdvX: 444,
    d: "M224-191q-79 0-129 42T45-25q0 32 11 57t29 49 36 44 34 44 25 49 6 58h102q5-37-3-66t-22-55-33-46-35-42-28-41-11-43q0-35 21-57t61-23q30 0 55 14t47 38l65-59q-34-38-79-62t-102-25zm12 538q-32 0-53 22t-21 57q0 33 21 55t53 22q32 0 53-22t21-55q0-35-21-57t-53-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC0",
    glyphName: "Agrave",
    horizAdvX: 558,
    d: "M217 348l-23-80h167l-23 80q-16 52-30 107t-29 109h-4q-14-55-28-109t-30-107zM-2 0l213 654h136L560 0H438l-51 177H167L116 0H-2zm293 688L123 805l62 76 157-135-51-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC1",
    glyphName: "Aacute",
    horizAdvX: 558,
    d: "M217 348l-23-80h167l-23 80q-16 52-30 107t-29 109h-4q-14-55-28-109t-30-107zM-2 0l213 654h136L560 0H438l-51 177H167L116 0H-2zm265 688l-51 58 157 135 62-76-168-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC2",
    glyphName: "Acircumflex",
    horizAdvX: 558,
    d: "M217 348l-23-80h167l-23 80q-16 52-30 107t-29 109h-4q-14-55-28-109t-30-107zM-2 0l213 654h136L560 0H438l-51 177H167L116 0H-2zm120 725l97 111h124l97-111-50-33-107 88h-4l-107-88-50 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC3",
    glyphName: "Atilde",
    horizAdvX: 558,
    d: "M217 348l-23-80h167l-23 80q-16 52-30 107t-29 109h-4q-14-55-28-109t-30-107zM-2 0l213 654h136L560 0H438l-51 177H167L116 0H-2zm352 700q-27 0-47 10t-37 22-30 22-29 10q-17 0-28-13t-14-44l-76 6q4 67 35 100t80 33q27 0 47-10t37-22 30-22 29-10q35 0 42 58l76-6q-4-67-35-100t-80-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC4",
    glyphName: "Adieresis",
    horizAdvX: 558,
    d: "M217 348l-23-80h167l-23 80q-16 52-30 107t-29 109h-4q-14-55-28-109t-30-107zM-2 0l213 654h136L560 0H438l-51 177H167L116 0H-2zm172 708q-26 0-42 16t-17 43q0 26 16 43t43 17q26 0 43-17t17-43q0-26-17-42t-43-17zm214 0q-26 0-43 16t-17 43q0 26 17 43t43 17q26 0 42-17t17-43q0-26-16-42t-43-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC5",
    glyphName: "Aring",
    horizAdvX: 558,
    d: "M217 348l-23-80h167l-23 80q-16 52-30 107t-29 109h-4q-14-55-28-109t-30-107zM-2 0l213 654h136L560 0H438l-51 177H167L116 0H-2zm279 698q-47 0-76 25t-30 69q0 44 29 69t77 26q46 0 76-25t30-70q0-43-30-68t-76-26zm0 46q19 0 32 12t14 36q0 23-13 36t-33 13q-20 0-33-13t-14-36q0-23 13-35t34-13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC6",
    glyphName: "AE",
    horizAdvX: 834,
    d: "M297 366l-51-105h148v304h-4q-24-51-47-101t-46-98zM-3 0l327 654h449v-98H510V389h221v-98H510V98h273V0H394v170H202L119 0H-3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC7",
    glyphName: "Ccedilla",
    horizAdvX: 576,
    d: "M344-12q-62 0-116 22t-93 65-63 106-23 144q0 80 23 143t64 108 95 67 117 23q62 0 110-25t79-58l-62-75q-26 26-56 41t-68 16q-40 0-73-16t-58-47-38-75-14-99q0-112 48-175t132-64q44 0 78 18t62 49l62-73q-40-46-91-70T344-12zm-92-221l-10 50q61 4 83 14t23 33q0 17-16 28t-61 17l46 94h70l-29-65q36-9 55-25t20-48q0-48-47-71t-134-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC8",
    glyphName: "Egrave",
    horizAdvX: 538,
    d: "M83 0v654h394v-98H199V389h235v-98H199V98h288V0H83zm218 688L133 805l62 76 157-135-51-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC9",
    glyphName: "Eacute",
    horizAdvX: 538,
    d: "M83 0v654h394v-98H199V389h235v-98H199V98h288V0H83zm190 688l-51 58 157 135 62-76-168-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCA",
    glyphName: "Ecircumflex",
    horizAdvX: 538,
    d: "M83 0v654h394v-98H199V389h235v-98H199V98h288V0H83zm45 725l97 111h124l97-111-50-33-107 88h-4l-107-88-50 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCB",
    glyphName: "Edieresis",
    horizAdvX: 538,
    d: "M83 0v654h394v-98H199V389h235v-98H199V98h288V0H83zm97 708q-26 0-42 16t-17 43q0 26 16 43t43 17q26 0 43-17t17-43q0-26-17-42t-43-17zm214 0q-26 0-43 16t-17 43q0 26 17 43t43 17q26 0 42-17t17-43q0-26-16-42t-43-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCC",
    glyphName: "Igrave",
    horizAdvX: 282,
    d: "M83 0v654h116V0H83zm72 688L-13 805l62 76 157-135-51-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCD",
    glyphName: "Iacute",
    horizAdvX: 282,
    d: "M83 0v654h116V0H83zm44 688l-51 58 157 135 62-76-168-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCE",
    glyphName: "Icircumflex",
    horizAdvX: 282,
    d: "M83 0v654h116V0H83zM-18 725l97 111h124l97-111-50-33-107 88h-4L32 692l-50 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCF",
    glyphName: "Idieresis",
    horizAdvX: 282,
    d: "M83 0v654h116V0H83zM34 708q-26 0-42 16t-17 43q0 26 16 43t43 17q26 0 43-17t17-43q0-26-17-42t-43-17zm214 0q-26 0-43 16t-17 43q0 26 17 43t43 17q26 0 42-17t17-43q0-26-16-42t-43-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD0",
    glyphName: "Eth",
    horizAdvX: 649,
    d: "M30 311v55l77 4v284h175q150 0 234-81t84-243q0-81-21-143T517 84t-98-63T288 0H107v311H30zM223 94h51q100 0 153 57t54 179q0 120-54 175t-153 55h-51V370h137v-59H223V94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD1",
    glyphName: "Ntilde",
    horizAdvX: 656,
    d: "M83 0v654h119l204-368 67-139h4q-4 51-9 109t-6 114v284h111V0H454L250 368l-67 139h-4q4-52 9-109t6-112V0H83zm320 700q-27 0-47 10t-37 22-30 22-29 10q-17 0-28-13t-14-44l-76 6q4 67 35 100t80 33q27 0 47-10t37-22 30-22 29-10q35 0 42 58l76-6q-4-67-35-100t-80-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD2",
    glyphName: "Ograve",
    horizAdvX: 674,
    d: "M337-12q-64 0-117 23t-91 68-59 108-21 143q0 79 21 141t59 106 91 66 117 23q64 0 117-23t91-66 60-105 21-142q0-80-21-143T546 80t-92-68-117-24zm0 101q39 0 70 17t53 48 34 76 12 100q0 110-45 172t-124 63q-78 0-123-62t-46-173q0-55 12-99t34-76 53-49 70-17zm14 599L183 805l62 76 157-135-51-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD3",
    glyphName: "Oacute",
    horizAdvX: 674,
    d: "M337-12q-64 0-117 23t-91 68-59 108-21 143q0 79 21 141t59 106 91 66 117 23q64 0 117-23t91-66 60-105 21-142q0-80-21-143T546 80t-92-68-117-24zm0 101q39 0 70 17t53 48 34 76 12 100q0 110-45 172t-124 63q-78 0-123-62t-46-173q0-55 12-99t34-76 53-49 70-17zm-14 599l-51 58 157 135 62-76-168-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD4",
    glyphName: "Ocircumflex",
    horizAdvX: 674,
    d: "M337-12q-64 0-117 23t-91 68-59 108-21 143q0 79 21 141t59 106 91 66 117 23q64 0 117-23t91-66 60-105 21-142q0-80-21-143T546 80t-92-68-117-24zm0 101q39 0 70 17t53 48 34 76 12 100q0 110-45 172t-124 63q-78 0-123-62t-46-173q0-55 12-99t34-76 53-49 70-17zM178 725l97 111h124l97-111-50-33-107 88h-4l-107-88-50 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD5",
    glyphName: "Otilde",
    horizAdvX: 674,
    d: "M337-12q-64 0-117 23t-91 68-59 108-21 143q0 79 21 141t59 106 91 66 117 23q64 0 117-23t91-66 60-105 21-142q0-80-21-143T546 80t-92-68-117-24zm0 101q39 0 70 17t53 48 34 76 12 100q0 110-45 172t-124 63q-78 0-123-62t-46-173q0-55 12-99t34-76 53-49 70-17zm73 611q-27 0-47 10t-37 22-30 22-29 10q-17 0-28-13t-14-44l-76 6q4 67 35 100t80 33q27 0 47-10t37-22 30-22 29-10q35 0 42 58l76-6q-4-67-35-100t-80-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD6",
    glyphName: "Odieresis",
    horizAdvX: 674,
    d: "M337-12q-64 0-117 23t-91 68-59 108-21 143q0 79 21 141t59 106 91 66 117 23q64 0 117-23t91-66 60-105 21-142q0-80-21-143T546 80t-92-68-117-24zm0 101q39 0 70 17t53 48 34 76 12 100q0 110-45 172t-124 63q-78 0-123-62t-46-173q0-55 12-99t34-76 53-49 70-17zM230 708q-26 0-42 16t-17 43q0 26 16 43t43 17q26 0 43-17t17-43q0-26-17-42t-43-17zm214 0q-26 0-43 16t-17 43q0 26 17 43t43 17q26 0 42-17t17-43q0-26-16-42t-43-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD7",
    glyphName: "multiply",
    horizAdvX: 513,
    d: "M108 119l-59 60 148 150L49 480l59 60 148-152 149 152 59-60-149-151 149-150-59-60-149 151-148-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD8",
    glyphName: "Oslash",
    horizAdvX: 674,
    d: "M339-12q-100 0-170 56l-63-80-61 48 70 89q-31 43-47 100T51 330q0 79 21 141t59 106 91 66 117 23q103 0 175-57l64 81 62-48-72-91q29-42 44-97t16-124q0-80-21-143T548 80t-92-68-117-24zM170 330q0-38 5-71t17-60l254 323q-43 43-107 43-78 0-123-62t-46-173zM339 89q39 0 70 17t53 48 34 76 12 100q0 68-19 120L237 130q41-41 102-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD9",
    glyphName: "Ugrave",
    horizAdvX: 655,
    d: "M328-12q-57 0-102 16t-78 53-50 92-18 138v367h116V278q0-53 9-89t27-59 42-31 54-10q30 0 55 9t43 32 28 58 10 90v376h111V287q0-81-17-137t-49-93-78-52-103-17zm13 700L173 805l62 76 157-135-51-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDA",
    glyphName: "Uacute",
    horizAdvX: 655,
    d: "M328-12q-57 0-102 16t-78 53-50 92-18 138v367h116V278q0-53 9-89t27-59 42-31 54-10q30 0 55 9t43 32 28 58 10 90v376h111V287q0-81-17-137t-49-93-78-52-103-17zm-15 700l-51 58 157 135 62-76-168-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDB",
    glyphName: "Ucircumflex",
    horizAdvX: 655,
    d: "M328-12q-57 0-102 16t-78 53-50 92-18 138v367h116V278q0-53 9-89t27-59 42-31 54-10q30 0 55 9t43 32 28 58 10 90v376h111V287q0-81-17-137t-49-93-78-52-103-17zM168 725l97 111h124l97-111-50-33-107 88h-4l-107-88-50 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDC",
    glyphName: "Udieresis",
    horizAdvX: 655,
    d: "M328-12q-57 0-102 16t-78 53-50 92-18 138v367h116V278q0-53 9-89t27-59 42-31 54-10q30 0 55 9t43 32 28 58 10 90v376h111V287q0-81-17-137t-49-93-78-52-103-17zM220 708q-26 0-42 16t-17 43q0 26 16 43t43 17q26 0 43-17t17-43q0-26-17-42t-43-17zm214 0q-26 0-43 16t-17 43q0 26 17 43t43 17q26 0 42-17t17-43q0-26-16-42t-43-17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDD",
    glyphName: "Yacute",
    horizAdvX: 501,
    d: "M192 0v243L-4 654h124l71-167q14-37 28-71t30-73h4q16 38 31 72t29 72l71 167h121L308 243V0H192zm44 688l-51 58 157 135 62-76-168-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDE",
    glyphName: "Thorn",
    horizAdvX: 600,
    d: "M83 0v654h116V550h104q54 0 99-10t79-34 52-62 19-96q0-55-19-95t-52-66-79-38-99-13H199V0H83zm116 229h95q144 0 144 119 0 61-36 85t-108 24h-95V229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDF",
    glyphName: "germandbls",
    horizAdvX: 604,
    d: "M404-12q-42 0-77 12t-69 35l42 79q51-39 101-39 33 0 51 19t18 45q0 24-14 40t-34 29-45 25-44 28-35 39-14 57q0 31 12 53t27 43 27 42 13 52q0 34-18 56t-55 22q-50 0-76-36t-27-105V0H73v501q0 48 14 87t41 68 67 44 95 16q45 0 79-13t58-34 35-50 12-59q0-37-13-62t-29-46-29-40-13-41q0-20 14-34t34-26 45-24 45-31 35-46 14-66q0-33-11-61t-34-50-54-33-74-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE0",
    glyphName: "agrave",
    horizAdvX: 516,
    d: "M192-12q-65 0-105 39T47 132q0 39 16 69t52 53 90 37 131 23q-1 19-5 36t-15 31-28 21-42 8q-36 0-70-14t-68-34l-42 77q41 26 92 45t110 19q92 0 137-54t46-158V0h-95l-8 54h-4q-33-28-70-47t-82-19zm37 90q30 0 54 14t53 40v110q-50-6-84-16t-55-22-30-29-9-34q0-33 20-48t51-15zm42 495L101 728l80 76 147-174-57-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE1",
    glyphName: "aacute",
    horizAdvX: 516,
    d: "M192-12q-65 0-105 39T47 132q0 39 16 69t52 53 90 37 131 23q-1 19-5 36t-15 31-28 21-42 8q-36 0-70-14t-68-34l-42 77q41 26 92 45t110 19q92 0 137-54t46-158V0h-95l-8 54h-4q-33-28-70-47t-82-19zm37 90q30 0 54 14t53 40v110q-50-6-84-16t-55-22-30-29-9-34q0-33 20-48t51-15zm38 495l-57 57 147 174 80-76-170-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE2",
    glyphName: "acircumflex",
    horizAdvX: 516,
    d: "M192-12q-65 0-105 39T47 132q0 39 16 69t52 53 90 37 131 23q-1 19-5 36t-15 31-28 21-42 8q-36 0-70-14t-68-34l-42 77q41 26 92 45t110 19q92 0 137-54t46-158V0h-95l-8 54h-4q-33-28-70-47t-82-19zm37 90q30 0 54 14t53 40v110q-50-6-84-16t-55-22-30-29-9-34q0-33 20-48t51-15zM100 607l111 135h116l111-135-45-43-122 103h-4L145 564l-45 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE3",
    glyphName: "atilde",
    horizAdvX: 516,
    d: "M192-12q-65 0-105 39T47 132q0 39 16 69t52 53 90 37 131 23q-1 19-5 36t-15 31-28 21-42 8q-36 0-70-14t-68-34l-42 77q41 26 92 45t110 19q92 0 137-54t46-158V0h-95l-8 54h-4q-33-28-70-47t-82-19zm37 90q30 0 54 14t53 40v110q-50-6-84-16t-55-22-30-29-9-34q0-33 20-48t51-15zm109 497q-25 0-44 11t-34 26-29 25-29 12q-35 0-41-67l-74 4q2 69 30 106t83 38q25 0 44-11t34-26 30-25 29-12q18 0 27 17t13 50l74-4q-2-68-30-106t-83-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE4",
    glyphName: "adieresis",
    horizAdvX: 516,
    d: "M192-12q-65 0-105 39T47 132q0 39 16 69t52 53 90 37 131 23q-1 19-5 36t-15 31-28 21-42 8q-36 0-70-14t-68-34l-42 77q41 26 92 45t110 19q92 0 137-54t46-158V0h-95l-8 54h-4q-33-28-70-47t-82-19zm37 90q30 0 54 14t53 40v110q-50-6-84-16t-55-22-30-29-9-34q0-33 20-48t51-15zm-63 500q-26 0-43 17t-18 44q0 26 17 43t44 18q27 0 44-17t17-44q0-26-17-43t-44-18zm206 0q-27 0-44 17t-17 44q0 26 17 43t44 18q26 0 43-17t18-44q0-26-17-43t-44-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE5",
    glyphName: "aring",
    horizAdvX: 516,
    d: "M192-12q-65 0-105 39T47 132q0 39 16 69t52 53 90 37 131 23q-1 19-5 36t-15 31-28 21-42 8q-36 0-70-14t-68-34l-42 77q41 26 92 45t110 19q92 0 137-54t46-158V0h-95l-8 54h-4q-33-28-70-47t-82-19zm37 90q30 0 54 14t53 40v110q-50-6-84-16t-55-22-30-29-9-34q0-33 20-48t51-15zm40 481q-58 0-89 29t-32 72q0 44 31 73t90 29q58 0 89-29t32-73q0-43-31-72t-90-29zm0 46q21 0 35 15t15 40q0 26-14 41t-36 15q-21 0-35-15t-15-41q0-25 14-40t36-15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE6",
    glyphName: "ae",
    horizAdvX: 785,
    d: "M198-12q-65 0-105 39T52 132q0 79 68 122t218 60q-1 19-5 36t-15 31-26 21-42 8q-35 0-69-14t-67-34l-42 77q41 26 90 45t103 19q51 0 85-23t54-66q30 42 67 65t86 24q47 0 82-17t60-49 36-74 13-95q0-34-5-54H443q6-64 43-99t92-35q32 0 58 10t53 28l41-77q-35-23-77-38t-90-15q-58 0-100 24t-71 60q-51-44-98-64t-96-20zm36 90q29 0 61 15t59 43q-8 17-11 39t-5 44l-2 23q-94-13-133-38t-39-63q0-33 19-48t51-15zm209 209h206q0 60-24 93t-72 34q-42 0-72-33t-38-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE7",
    glyphName: "ccedilla",
    horizAdvX: 462,
    d: "M278-12q-50 0-93 17t-76 50-50 81-18 109q0 61 20 109t54 81 78 50 94 18q48 0 82-16t62-39l-56-75q-20 17-39 26t-43 10q-60 0-97-44t-37-120q0-74 36-118t95-45q29 0 54 12t47 30l47-76q-35-30-76-45t-84-15zm-94-221l-10 50q61 4 83 14t23 33q0 17-16 28t-61 17l46 94h70l-29-65q36-9 55-25t20-48q0-48-47-71t-134-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE8",
    glyphName: "egrave",
    horizAdvX: 507,
    d: "M283-12q-51 0-95 17t-77 51-51 80-19 109q0 60 19 108t50 81 73 51 84 18q50 0 88-17t63-48 39-74 13-94q0-17-1-32t-4-24H153q8-66 46-101t99-36q32 0 59 9t55 27l39-72q-35-23-78-38t-90-15zM152 292h218q0 57-24 89t-76 33q-44 0-77-31t-41-91zm117 281L99 728l80 76 147-174-57-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE9",
    glyphName: "eacute",
    horizAdvX: 507,
    d: "M283-12q-51 0-95 17t-77 51-51 80-19 109q0 60 19 108t50 81 73 51 84 18q50 0 88-17t63-48 39-74 13-94q0-17-1-32t-4-24H153q8-66 46-101t99-36q32 0 59 9t55 27l39-72q-35-23-78-38t-90-15zM152 292h218q0 57-24 89t-76 33q-44 0-77-31t-41-91zm113 281l-57 57 147 174 80-76-170-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEA",
    glyphName: "ecircumflex",
    horizAdvX: 507,
    d: "M283-12q-51 0-95 17t-77 51-51 80-19 109q0 60 19 108t50 81 73 51 84 18q50 0 88-17t63-48 39-74 13-94q0-17-1-32t-4-24H153q8-66 46-101t99-36q32 0 59 9t55 27l39-72q-35-23-78-38t-90-15zM152 292h218q0 57-24 89t-76 33q-44 0-77-31t-41-91zM98 607l111 135h116l111-135-45-43-122 103h-4L143 564l-45 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEB",
    glyphName: "edieresis",
    horizAdvX: 507,
    d: "M283-12q-51 0-95 17t-77 51-51 80-19 109q0 60 19 108t50 81 73 51 84 18q50 0 88-17t63-48 39-74 13-94q0-17-1-32t-4-24H153q8-66 46-101t99-36q32 0 59 9t55 27l39-72q-35-23-78-38t-90-15zM152 292h218q0 57-24 89t-76 33q-44 0-77-31t-41-91zm12 286q-26 0-43 17t-18 44q0 26 17 43t44 18q27 0 44-17t17-44q0-26-17-43t-44-18zm206 0q-27 0-44 17t-17 44q0 26 17 43t44 18q26 0 43-17t18-44q0-26-17-43t-44-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEC",
    glyphName: "igrave",
    horizAdvX: 262,
    d: "M73 0v491h115V0H73zm60 573L-37 728l80 76 147-174-57-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xED",
    glyphName: "iacute",
    horizAdvX: 262,
    d: "M73 0v491h115V0H73zm56 573l-57 57 147 174 80-76-170-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEE",
    glyphName: "icircumflex",
    horizAdvX: 262,
    d: "M73 0v491h115V0H73zM-38 607L73 742h116l111-135-45-43-122 103h-4L7 564l-45 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEF",
    glyphName: "idieresis",
    horizAdvX: 262,
    d: "M73 0v491h115V0H73zM28 578q-26 0-43 17t-18 44q0 26 17 43t44 18q27 0 44-17t17-44q0-26-17-43t-44-18zm206 0q-27 0-44 17t-17 44q0 26 17 43t44 18q26 0 43-17t18-44q0-26-17-43t-44-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF0",
    glyphName: "eth",
    horizAdvX: 552,
    d: "M271-12q-45 0-85 16t-71 47-49 75-18 99q0 52 16 94t45 71 65 45 78 16q34 0 65-12t55-42q-14 50-38 89t-58 73l-142-72-31 53 122 62q-23 17-48 32t-53 30l51 71q36-19 71-40t67-48l143 73 31-54-124-63q59-60 97-143t38-198q0-60-16-110t-45-87-72-57-94-20zm3 94q55 0 85 45t30 129v25q0 12-2 25-27 34-55 46t-59 12q-55 0-87-37t-32-102q0-33 9-59t26-45 39-29 46-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF1",
    glyphName: "ntilde",
    horizAdvX: 560,
    d: "M73 0v491h95l8-66h4q33 32 71 55t90 23q79 0 115-50t36-145V0H377v293q0 61-18 86t-59 25q-32 0-56-15t-56-46V0H73zm296 575q-25 0-44 11t-34 26-29 25-29 12q-35 0-41-67l-74 4q2 69 30 106t83 38q25 0 44-11t34-26 30-25 29-12q18 0 27 17t13 50l74-4q-2-68-30-106t-83-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF2",
    glyphName: "ograve",
    horizAdvX: 549,
    d: "M274-12q-46 0-88 17t-74 50-52 81-19 109q0 61 19 109t51 81 75 50 88 18q46 0 88-17t75-51 51-81 20-109q0-61-19-109t-52-81-74-50-89-17zm0 94q54 0 85 44t31 119q0 75-31 119t-85 45q-54 0-84-44t-31-120q0-74 30-118t85-45zm2 491L106 728l80 76 147-174-57-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF3",
    glyphName: "oacute",
    horizAdvX: 549,
    d: "M274-12q-46 0-88 17t-74 50-52 81-19 109q0 61 19 109t51 81 75 50 88 18q46 0 88-17t75-51 51-81 20-109q0-61-19-109t-52-81-74-50-89-17zm0 94q54 0 85 44t31 119q0 75-31 119t-85 45q-54 0-84-44t-31-120q0-74 30-118t85-45zm-2 491l-57 57 147 174 80-76-170-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF4",
    glyphName: "ocircumflex",
    horizAdvX: 549,
    d: "M274-12q-46 0-88 17t-74 50-52 81-19 109q0 61 19 109t51 81 75 50 88 18q46 0 88-17t75-51 51-81 20-109q0-61-19-109t-52-81-74-50-89-17zm0 94q54 0 85 44t31 119q0 75-31 119t-85 45q-54 0-84-44t-31-120q0-74 30-118t85-45zM105 607l111 135h116l111-135-45-43-122 103h-4L150 564l-45 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF5",
    glyphName: "otilde",
    horizAdvX: 549,
    d: "M274-12q-46 0-88 17t-74 50-52 81-19 109q0 61 19 109t51 81 75 50 88 18q46 0 88-17t75-51 51-81 20-109q0-61-19-109t-52-81-74-50-89-17zm0 94q54 0 85 44t31 119q0 75-31 119t-85 45q-54 0-84-44t-31-120q0-74 30-118t85-45zm69 493q-25 0-44 11t-34 26-29 25-29 12q-35 0-41-67l-74 4q2 69 30 106t83 38q25 0 44-11t34-26 30-25 29-12q18 0 27 17t13 50l74-4q-2-68-30-106t-83-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF6",
    glyphName: "odieresis",
    horizAdvX: 549,
    d: "M274-12q-46 0-88 17t-74 50-52 81-19 109q0 61 19 109t51 81 75 50 88 18q46 0 88-17t75-51 51-81 20-109q0-61-19-109t-52-81-74-50-89-17zm0 94q54 0 85 44t31 119q0 75-31 119t-85 45q-54 0-84-44t-31-120q0-74 30-118t85-45zM171 578q-26 0-43 17t-18 44q0 26 17 43t44 18q27 0 44-17t17-44q0-26-17-43t-44-18zm206 0q-27 0-44 17t-17 44q0 26 17 43t44 18q26 0 43-17t18-44q0-26-17-43t-44-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF7",
    glyphName: "divide",
    horizAdvX: 513,
    d: "M34 288v84h445v-84H34zM256 84q-29 0-48 18t-20 48q0 29 19 47t49 18q29 0 48-18t20-47q0-29-19-47t-49-19zm0 360q-29 0-48 18t-20 48q0 29 19 47t49 18q29 0 48-18t20-47q0-29-19-47t-49-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF8",
    glyphName: "oslash",
    horizAdvX: 549,
    d: "M274-12q-37 0-72 11t-64 33L92-24 46 12l50 61q-26 32-40 75t-15 97q0 61 19 109t51 81 75 50 88 18q77 0 136-44l47 57 46-36-50-62q26-32 40-75t15-98q0-61-19-109t-52-81-74-50-89-17zM153 251q0-52 14-91l182 224q-31 29-75 29-54 0-87-45t-34-117zM274 78q54 0 88 44t34 117q0 53-14 92L199 108q30-30 75-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF9",
    glyphName: "ugrave",
    horizAdvX: 556,
    d: "M219-12q-79 0-115 50T68 183v308h115V198q0-61 18-86t58-25q32 0 56 16t53 52v336h115V0h-94l-9 72h-3q-32-38-69-61t-89-23zm62 585L111 728l80 76 147-174-57-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFA",
    glyphName: "uacute",
    horizAdvX: 556,
    d: "M219-12q-79 0-115 50T68 183v308h115V198q0-61 18-86t58-25q32 0 56 16t53 52v336h115V0h-94l-9 72h-3q-32-38-69-61t-89-23zm58 585l-57 57 147 174 80-76-170-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFB",
    glyphName: "ucircumflex",
    horizAdvX: 556,
    d: "M219-12q-79 0-115 50T68 183v308h115V198q0-61 18-86t58-25q32 0 56 16t53 52v336h115V0h-94l-9 72h-3q-32-38-69-61t-89-23zM110 607l111 135h116l111-135-45-43-122 103h-4L155 564l-45 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFC",
    glyphName: "udieresis",
    horizAdvX: 556,
    d: "M219-12q-79 0-115 50T68 183v308h115V198q0-61 18-86t58-25q32 0 56 16t53 52v336h115V0h-94l-9 72h-3q-32-38-69-61t-89-23zm-43 590q-26 0-43 17t-18 44q0 26 17 43t44 18q27 0 44-17t17-44q0-26-17-43t-44-18zm206 0q-27 0-44 17t-17 44q0 26 17 43t44 18q26 0 43-17t18-44q0-26-17-43t-44-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFD",
    glyphName: "yacute",
    horizAdvX: 495,
    d: "M106-202q-20 0-35 2t-29 8l21 90q7-2 16-4t19-3q39 0 62 23t36 61l9 31L12 491h117l85-241q11-32 21-67t22-71h4q9 34 18 69t19 69l74 241h111L305-22q-15-42-33-75t-41-56-54-36-71-13zm147 775l-57 57 147 174 80-76-170-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFE",
    glyphName: "thorn",
    horizAdvX: 564,
    d: "M73-194v900h115V524l-2-77q29 24 63 40t73 16q47 0 84-17t62-51 39-79 14-103q0-63-17-112t-47-83-67-52-79-18q-35 0-65 13t-60 37l2-78v-154H73zM287 83q49 0 82 42t33 127q0 74-25 115t-81 41q-52 0-108-55V124q27-23 52-32t47-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFF",
    glyphName: "ydieresis",
    horizAdvX: 495,
    d: "M106-202q-20 0-35 2t-29 8l21 90q7-2 16-4t19-3q39 0 62 23t36 61l9 31L12 491h117l85-241q11-32 21-67t22-71h4q9 34 18 69t19 69l74 241h111L305-22q-15-42-33-75t-41-56-54-36-71-13zm46 780q-26 0-43 17t-18 44q0 26 17 43t44 18q27 0 44-17t17-44q0-26-17-43t-44-18zm206 0q-27 0-44 17t-17 44q0 26 17 43t44 18q26 0 43-17t18-44q0-26-17-43t-44-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2013",
    glyphName: "endash",
    horizAdvX: 480,
    d: "M42 214v76h396v-76H42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2014",
    glyphName: "emdash",
    horizAdvX: 800,
    d: "M42 214v76h716v-76H42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2018",
    glyphName: "quoteleft",
    horizAdvX: 275,
    d: "M134 382q-38 0-58 29t-20 82q0 131 124 196l28-51q-42-24-62-53t-21-73q3 1 9 1 27 0 46-16t20-46q0-32-18-50t-48-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2019",
    glyphName: "quoteright",
    horizAdvX: 275,
    d: "M95 391l-28 51q42 24 62 53t21 73q-3-1-9-1-26 0-45 16t-20 46q0 32 18 50t47 19q38 0 58-29t21-82q0-131-125-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201A",
    glyphName: "quotesinglbase",
    horizAdvX: 275,
    d: "M95-156l-28 51q42 24 62 53t21 73q-3-1-9-1-26 0-45 16T76 82q0 32 18 50t47 19q38 0 58-29t21-82q0-131-125-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201C",
    glyphName: "quotedblleft",
    horizAdvX: 482,
    d: "M134 382q-38 0-58 29t-20 82q0 131 124 196l28-51q-42-24-62-53t-21-73q3 1 9 1 27 0 46-16t20-46q0-32-18-50t-48-19zm207 0q-38 0-58 29t-20 82q0 131 124 196l28-51q-42-24-62-53t-21-73q3 1 9 1 27 0 46-16t20-46q0-32-18-50t-48-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201D",
    glyphName: "quotedblright",
    horizAdvX: 482,
    d: "M95 391l-28 51q42 24 62 53t21 73q-3-1-9-1-26 0-45 16t-20 46q0 32 18 50t47 19q38 0 58-29t21-82q0-131-125-196zm207 0l-28 51q42 24 62 53t21 73q-3-1-9-1-26 0-45 16t-20 46q0 32 18 50t47 19q38 0 58-29t21-82q0-131-125-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201E",
    glyphName: "quotedblbase",
    horizAdvX: 482,
    d: "M95-156l-28 51q42 24 62 53t21 73q-3-1-9-1-26 0-45 16T76 82q0 32 18 50t47 19q38 0 58-29t21-82q0-131-125-196zm207 0l-28 51q42 24 62 53t21 73q-3-1-9-1-26 0-45 16t-20 46q0 32 18 50t47 19q38 0 58-29t21-82q0-131-125-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2022",
    glyphName: "bullet",
    horizAdvX: 325,
    d: "M162 133q-25 0-47 9t-39 27-26 41-10 53q0 28 9 52t26 41 39 27 48 10q25 0 47-10t40-27 26-41 10-52q0-29-9-52t-27-41-39-27-48-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2039",
    glyphName: "guilsinglleft",
    horizAdvX: 282,
    d: "M182 61L47 210v84l135 149 46-37-115-154L228 97l-46-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u203A",
    glyphName: "guilsinglright",
    horizAdvX: 282,
    d: "M99 61L54 97l114 155L54 406l45 37 136-149v-84L99 61z"
  })))));
}

export default SvgSourceSansProSemiBold;